<template>
  <div
    class="asset-library"
    :class="[
      { 'asset-library--relative' : isInline },
      { 'asset-library--inactive' : isUploading }
    ]"
  >
    <div v-if="isUploading" class="asset-library__loading-icon">
      <fa :icon="['fad', 'spinner-third']" />
    </div>
    <div class="asset-library__modal">
      <button v-if="!isInline" class="btn btn-sm btn-dark d-block ml-auto mr-0" @click="$emit('close')">Close</button>
      <h3 class="asset-library__heading">Asset Library</h3>

      <div class="row my-4">
        <div class="col-4">
          <div class="asset-library__categories">
            <label for="">Category</label>
            <select v-model="selectedCategory" class="form-control">
              <option value="">All</option>
              <option v-for="category in assetCategories" :key="category" :value="category">{{ transformToStartCase(category) }}</option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <label for="">File Type</label>
          <select v-model="selectedType" class="form-control">
            <option value="">All</option>
            <option value="image">Image</option>
            <option value="video">Video</option>
            <option value="pdf">PDF</option>
          </select>
        </div>
        <div class="col-4">
          <label for="">Filter</label>
          <input class="form-control form-control w-100" type="text" v-model="filterString">
        </div>
      </div>
      <div 
        class="asset-library__assets-wrapper my-4"
        :class="{ 'asset-library__assets-wrapper--full' : isInline }"
        ref="assetsWrapper"
      >
        <div class="asset-library__assets">
          <div 
            class="asset-library__asset-wrapper"
            v-for="asset in filteredAssets" 
            :key="asset._id"
          >
            <div
              class="asset-library__asset"
              :class="{ 'asset-library__asset--active': isActive(asset) }"
              :ref="isActive(asset) ? 'selectedAsset': false"
              @click="selectAsset(asset)"
            >
              <fa v-show="isActive(asset)" class="asset-library__active-indicator" :icon="['fas', 'check']" size="lg"></fa>
              <img 
                class="asset-library__thumbnail"
                :src="asset.type === 'pdf' ?  require('../assets/img/pdf-thumb.jpg') : asset.customThumbPath ? $store.state.assetsPath + asset.customThumbPath : $store.state.assetsPath + asset.thumbPath" 
              >
              <div class="asset-library__details">
                <div v-if="!isActive(asset) || !(isEditingAsset === asset)" class="asset-library__description">{{ asset.description || 'No description' }}</div>
                <div v-if="isActive(asset) && isEditingAsset === asset" class="asset-library__description-input" @click.stop><input type="text" v-model="asset.description" /></div>
                <!-- <div class="asset-library__path">Asset path: {{ asset.path }}</div>
                <div class="asset-library__path">Asset Thumbnail path: {{ asset.thumbPath }}</div>
                <div v-if="asset.type == 'video' && (!isActive(asset) || !(isEditingAsset === asset))" class="asset-library__path">Custom Thumbnail: {{ asset.customThumbPath }}</div>
                <div v-if="isActive(asset) && isEditingAsset === asset && asset.type == 'video'" class="asset-library__description-input" @click.stop>Custom Thumbnail: <input type="text" v-model="asset.customThumbPath" /></div> -->
                <div class="asset-library__asset-controls">
                  <button class="btn btn-sm btn-secondary asset-library__edit-button" v-if="isActive(asset) && !(isEditingAsset === asset)" @click.stop="isEditingAsset = asset">Edit</button>
                  <button class="btn btn-sm btn-primary" v-if="isActive(asset) && isEditingAsset === asset" @click.stop="updateAsset(asset)">Save</button>
                  <!-- <button v-if="selectedAsset ? selectedAsset.path === asset.path : false">Delete</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-outline-danger" @click="deleteAsset()" :disabled="multiple ? ! selectedAssets.length : !selectedAsset">Delete Selected Asset{{ multiple ? 's' : '' }}</button>
      <button v-if="!isInline" class="float-right btn btn-primary" @click="useAsset()" :disabled="multiple ? ! selectedAssets.length : !selectedAsset">Use Selected Asset{{ multiple ? 's' : '' }}</button>
      
      <h3 class="mt-5">Upload Asset</h3>
      <div class="asset-library__upload">
        <div class="row">
          <div class="col-4">
            <label for="assetDescription">Choose Asset File</label>
            <input type="file" name="asset" ref="assetInput" id="asset" @change="isUploadFileChosen = !!$refs.assetInput.files.length" multiple>
          </div>
          <div class="col-4">
            <label for="assetDescription">Asset Description</label>
            <input class="w-100" id="assetDescription" type="text" v-model="assetDescription" placeholder="i.e. masterplan">
          </div>
          <div class="col-4">
            <label>&nbsp;</label>
            <button class="float-right btn btn-sm btn-secondary" :disabled="!isUploadFileChosen" @click="createAsset($refs.assetInput.files)">Upload Asset</button>
          </div>
        </div>
      </div>
        
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'
import { ASSET_DELETE } from '@/store/actions.type'

export default {
  props: ['multiple', 'value', 'isInline', 'defaultCategory', 'defaultType'],

  data () {
    return {
      assetDescription: '',
      filterString: '',
      isEditing: false,
      isEditingAsset: '',
      isUploadFileChosen: false,
      isUploading: false,
      selectedAsset: null,
      selectedAssets: [],
      selectedCategory: this.defaultCategory ? this.defaultCategory : '',
      selectedType: this.defaultType ? this.defaultType : ''
    }
  },

  computed: {
    assetCategories () {
      return _.orderBy(this.$store.state.assetLibrary.assetCategories)
    },

    assets () {
      return _.sortBy(this.$store.state.assetLibrary.assets, asset => {
        return asset.updatedAt
      }).reverse()
    },

    filteredAssets () {
      return _.filter(this.assets, asset => {
        if (this.selectedCategory === ''|| this.selectedCategory === asset.category) {
          if (this.selectedType === '') {
            return asset.description.toLowerCase().includes(this.filterString.toLowerCase()) || asset.path.toLowerCase().includes(this.filterString.toLowerCase())
          } else if (this.selectedType === asset.type) {
            return asset.description.toLowerCase().includes(this.filterString.toLowerCase()) || asset.path.toLowerCase().includes(this.filterString.toLowerCase())
          }
        }
      })
    },
  },

  mounted () {
    if (this.multiple) {
      this.selectedAssets = this.value
    } else {
      if (this.value !== null && this.$refs.selectedAsset !== undefined) {
        this.selectedAsset = this.value
        this.$nextTick(() => {
          this.$refs.assetsWrapper.scrollTop = this.$refs.selectedAsset[0].offsetTop - 15
        })
      }
    }
  },

  watch: {
    $props: {
      immediate: true,
      handler() {
        this.validateValue();
      }
    }
  },

  methods: {
    createAsset (files) {
      this.isUploading = true
      if (files.length > 1) {
        for (var i = 0; i < files.length; i++) {
          const asset = this.$store.dispatch('UPLOAD_ASSET', {
            category: this.selectedCategory ? this.selectedCategory : 'misc',
            description: files[i].name,
            file: files[i]
          }).then(() => {
            this.isUploading = false
          })
        }
      } else {
        const asset = this.$store.dispatch('UPLOAD_ASSET', {
          category: this.selectedCategory ? this.selectedCategory : 'misc',
          description: this.assetDescription ? this.assetDescription : files[0].name,
          file: files[0]
        }).then(() => {
          this.isUploading = false
        })
      }
      
      this.$refs.assetsWrapper.scrollTop = 0
      this.$refs.assetInput.value = ""
    },

    deleteAsset () {
      this.selectedAssets.forEach(asset => {
        this.$store
          .dispatch('deleteAsset', asset)
          .then(res => {
            if (res.data.errors) {
              throw res.data.errors 
            }
            this.$notify({
              message: `${asset.description} has been deleted`,
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "success"
            });
            this.selectedAssets = []
            this.$emit('updateAssets')
          })
          .catch(err => {
            if (typeof err === 'object') {
              err.forEach(error => {
                this.$notify({
                  message: error,
                  horizontalAlign: "center",
                  verticalAlign: "top",
                  type: "warning"
                });
              })
            } else {
              this.$notify({
                message: err.message,
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "warning"
              });
            }     
          })
      })
    },

    isActive (asset) {
      if (this.multiple) {
        let active = false
        this.selectedAssets.forEach(selectedAsset => {
          if (selectedAsset.path === asset.path) {
            active = true
          }
        })
        return active
      } else {
        return this.selectedAsset ? this.selectedAsset.path === asset.path : false
      }
    },

    selectAsset (asset) {
      this.isEditingAsset = null
      if (this.multiple) {
        if (this.isActive(asset)) {
          _.remove(this.selectedAssets, selectedAsset => {
            return selectedAsset.path === asset.path
          })
          this.selectedAssets = JSON.parse(JSON.stringify(this.selectedAssets))
        } else {
          this.selectedAssets.push(asset)
        }
      } else {
        this.selectedAsset = asset
      }
    },

    setSelectedCategory (category) {
      this.selectedCategory = category
    },

    transformToStartCase (string) {
      return _.startCase(_.camelCase(string))
    },

    updateAsset (asset) {
      this.isEditingAsset = null
      this.$store.dispatch('UPDATE_ASSET', asset)
      this.$refs.assetsWrapper.scrollTop = 0
    },

    useAsset () {
      if (this.multiple) {
        this.$emit('input', this.selectedAssets)
        this.$emit('close')
      } else {
        this.$emit('input', this.selectedAsset)
        this.$emit('close')
      }
    },

    validateValue () {
      if (this.multiple) {
        return Array.isArray(this.value)
      } else {
        return typeof this.value === 'string' || this.value === null
      }
    }
  }
}
</script>
<style lang="scss">
@import '@/styles/_animations.scss';
@import '@/styles/_mixins.scss';

  .asset-library {
    background: rgba(#000000, .5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    z-index: 999;

    &--inactive {
      pointer-events: none;
      user-select: none;

      .asset-library__modal > * {
        opacity: .8;
      }
    }

    &--relative {
      position: relative;

      .asset-library__modal {
        background: #fff;
        border-radius: 0;
        padding: 2em 0;
        width: 100%;
      }
    }

    &__loading-icon {
      color: green;
      font-size: 80px;
      left: 50%;
      pointer-events: none;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      user-select: none;
      z-index: 10;

      svg {
        animation-name: rotate;
        animation-duration: 3s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }
    }

    &__categories {

    }

    &__heading {
      margin-top: -1em;
    }

    &__modal {
      border-radius: 4px;
      background-color: #fff;
      padding: 2em;
      width: 80vw;
    }

    &__assets-wrapper {
      // border: 1px solid #eee;
      // border-radius: 4px;
      height: 350px;
      overflow: auto;
      margin-bottom: 15px;
      transition: height 0.3s;
      position: relative;

      &--compact {
        // height: 150px;
      }

      &--full {
        height: 100%;
        max-height: none;

        @include v-breakpoint(1000px) {
          max-height: calc(100vh - 680px);
        }
      }
    }

    &__assets {
      display: flex;
      flex-wrap: wrap;    
    }

    &__asset-wrapper {
      padding: 0 15px 15px 0;
      width: 50%;

      &:nth-child(2n) {
        padding: 0 0 15px 0;
      }
    }

    &__asset {
      border: 1px solid #d4d4d4;
      border-radius: 4px;
      cursor: pointer;
      display: flex;
      position: relative;

      &--active {
        border: 1px solid #80bdff !important;
      }

      .asset-library__edit-button {
          display: none;
        }

      &:hover {
        border: 1px solid #aaa;

        .asset-library__edit-button {
          display: inline-block;
        }
      }
    }

    &__active-indicator {
      position: absolute;
      top: 5px;
      right: 5px;

      color: #80bdff;
    }

    &__selected-asset {
      display: flex;
    }

    &__thumbnail {
      background-color: #eee;
      height: 120px;
      width: 180px;
      object-fit: contain;
      opacity: 0.7;
      flex-shrink: 0;

      .asset-library__asset--active & {
        position: relative;
        opacity: 1 !important;
      }
    }

    &__details {
      word-break: break-all;
      padding: 15px 15px;

      button {
        font-size: 0.8em;
        margin-left: 10px;
      }
    }

    &__asset-controls {
      position: absolute;
      right: 5px;
      bottom: 5px;
    }

    &__description {
      span {
        display: none;
        font-size: 0.9em;
        opacity: 0.7;
      }
    }
    
    &__path {
      opacity: 0.5;
      font-size: 0.8em;
    }

    &__upload {
      border: 1px solid #d4d4d4;
      border-radius: 4px;
      padding: 15px;
    }
  }
</style>